export function checkPasswordRequirements(string) {
    if (string && checkCharacterLength(string, 8) && checkUpperCaseLetter(string) && checkLowerCaseLetter(string) && checkNumber(string) && checkSymbol(string)) {
        return true;
    }

    return false;
}

export function checkPasswordsMatch(password, password_confirm) {
    if (password === password_confirm) {
        return true;
    }

    return false;
}

export function checkCharacterLength(string, length) {
    if (string && string.length >= length) {
        return true;
    }

    return false;
}

export function checkUpperCaseLetter(string) {
    if (string && /[A-Z]/.test(string)) {
        return true;
    }

    return false;
}

export function checkLowerCaseLetter(string) {
    if (string && /[a-z]/.test(string)) {
        return true;
    }

    return false;
}

export function checkNumber(string) {
    if (string && /[0-9]/.test(string)) {
        return true;
    }

    return false;
}

export function checkSymbol(string) {
    if (string && /[!@#$%*?&]/.test(string)) {
        return true;
    }

    return false;
}

export function validColour(strColour) {
    const s = new Option().style;
    s.color = strColour;
    return s.color !== '';
}

export const capitalize = s => s && s[0].toUpperCase() + s.slice(1)
